export const toDataType = (propertyDataType) => {
    if (propertyDataType === 'STRING') {
        return 'STRING';
    }
    if (propertyDataType === 'BOOLEAN') {
        return 'BOOLEAN';
    }
    return 'NUMBER';
};
